import {useFreshQuery} from '#lib/hooks/use-query.js';
import {useQuery, useInfiniteQuery} from '@tanstack/react-query';
import {getAuthHeader} from '#lib/hooks/use-auth.jsx';

function authorize(queryFn) {
    return async (args) => queryFn.call(this, args, await getAuthHeader());
}

export function useAuthQuery({queryFn, disableAuth = false, ...rest}) {
    return useQuery({
        queryFn: disableAuth ? queryFn : authorize(queryFn),
        ...rest
    });
}

export function useAuthInfiniteQuery({queryFn, disableAuth = false, ...rest}) {
    return useInfiniteQuery({
        queryFn: disableAuth ? queryFn : authorize(queryFn),
        ...rest
    });
}

export function useFreshAuthQuery(options) {
    return useFreshQuery(useAuthQuery, options);
}
